import type { User } from '../users/user'

export class DeviceEntity {
    deviceId: string
    userId: string
    lastUserId: string
    token: string
    createdAt: Date
    updatedAt: Date
    lastRequestAt: Date
    requestCount: number
    fcmToken?: string
    fcmTokenUpdatedAt?: Date
    label?: string
    description?: string
    metadata?: string
    status: number
    companyId: string
    expiresAt?: Date

    user?: User
    lastUser?: User
}
